let initialState = {
    tripList: [],
    tripListMsg:''
};

const Trip = (state = initialState, action) => {
    switch (action.type) {
        case 'TRIP_LIST':
            return {...state, tripList: action.sources, tripListMsg: action.tripListMsg}
        default:
            return state
    }
};
export default Trip;